import { render, staticRenderFns } from "./UnpairTableAgGridComponent.vue?vue&type=template&id=a0449e62&scoped=true&"
import script from "./UnpairTableAgGridComponent.vue?vue&type=script&lang=js&"
export * from "./UnpairTableAgGridComponent.vue?vue&type=script&lang=js&"
import style0 from "./UnpairTableAgGridComponent.vue?vue&type=style&index=0&id=a0449e62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0449e62",
  null
  
)

export default component.exports